module.exports = __webpack_public_path__ + "static/Attraqt-c1e3add8b6570e287e7972f65b4c76dc.png";